import { render, staticRenderFns } from "./AttendanceScreen.vue?vue&type=template&id=61b8a2cd&scoped=true"
import script from "./AttendanceScreen.vue?vue&type=script&lang=js"
export * from "./AttendanceScreen.vue?vue&type=script&lang=js"
import style0 from "./AttendanceScreen.vue?vue&type=style&index=0&id=61b8a2cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b8a2cd",
  null
  
)

export default component.exports